<template>
  <div class="home">
    <van-nav-bar
      title="套餐活动"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
   <van-swipe :autoplay="2000">
        <van-swipe-item
          
        >
          <img
            class="imgss"
            src="../../../assets/tao/01.jpg"
          />
          <!-- <img v-lazy="image.adv_img" /> -->
        </van-swipe-item>
        <!-- <van-swipe-item>
          <img src="../../assets/swipe.png" />
          <img v-lazy="image" />
        </van-swipe-item> -->
      </van-swipe>
    
       <div class="goods">
           <!-- <div class="activity">
        <div
          class="tu"
          @click="go"
        >
          <img
            src="../../assets/a1.jpg"
            alt=""
          />
        </div>
        <div class="wen">
          <div class="left">
            <p>各大活动，敬请期待</p>
            <p></p>
          </div>
          <div class="right">
            <van-count-down :time="time">
              <template v-slot="timeData">
                还剩
                <span class="item">{{ timeData.hours }}</span>: <span class="item">{{ timeData.minutes }}</span>:
                <span class="item">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
          </div>
        </div>
      </div> -->
      <div class="content">
        <ul class="clearfix">
          <li @click="go(v.id)" v-for='v in list' :key='v.id'>
         <div class="tao">
           <img :src="v.thumb" alt="">
         </div>           
         <!-- <div class="price">{{v.min_price}}</div>
         <div class="name">{{v.name}}</div> -->
          </li>          
        </ul>
      </div>
       </div>
       

  </div>
</template>
<script>
import Vue from 'vue'

import { NavBar, AddressList, Toast,Swipe, SwipeItem, Lazyload,CountDown,Progress } from 'vant'

Vue.use(NavBar).use(AddressList).use(Toast).use(Swipe)
  .use(SwipeItem)
  .use(Lazyload, { lazyComponent: true }).use(CountDown).use(Progress);
export default {
  created () {
   this.axios.get('listGoodsByCateBrand', { params: { store_id:1, class_id: 1649, class_name:'马六甲生态板套餐活动'} }).then(res => {
          console.log(res)
          this.list=res.data.data
        }).catch(ref => { })
   
  },
  destroyed(){
   

  },
  data () {
    return {
      chosenAddressId: '1',
       time: 3000,
     list:[],
     specs_show:false,
    sid:'',
    pname:'',
    oid:[],
    ptimg:[],
    };
  },
  methods: {
   
   
    onClickLeft () {
      this.$router.go(-1)
    },
   go(id){
    if(id==2894){
    this.$router.push({ name: 'taop', query: { id,h:1 } })

    }else{
    this.$router.push({ name: 'taop', query: { id,h:2 } })

    }
   },
   goa(id){
    Toast('龙骨具体优惠请联系业务员咨询~')
   }
    
    
  },
  components: {
 
    // One
  },
}
</script>
<style lang="less" scoped>
.home{
    //   background-color: #fee006;
height: 100%;
}
.activity {
    height: 6.266667rem;
    overflow: hidden;
    border-radius: 0.4rem;
    //   background-color: #fff600;

    .tu {
      width: 100%;
      height: 4.293333rem;
    }
    .wen {
    //   background-color: #fff600;
      height: 2rem;
      display: flex;
      .left {
        padding-top: 0.5rem;
        padding-left: 0.2rem;
        flex: 0.6;
        p:nth-child(1) {
          font-weight: 700;
          height: 0.64rem;
        }
        p:nth-child(2) {
          color: #f00;
        }
      }
      .right {
        color: #575c66;
        padding-top: 0.6rem;
        flex: 0.4;
      }
    }
  }
  .js{
    padding-top: 0.5rem;
    text-align: center;
    font-size: 0.45rem;
    color: rgb(59, 44, 44);
  }
  .content {
    height: 100%;
    //   background-color: #fee006;
    padding: 0.2rem 0;
   
    ul {
      li {
        float: left;
        width: 50%;
       padding: 0.25rem 0.2rem;
        // padding-left: 0.1rem;
        // padding-right: 0.1rem;
        // margin-left: 0.1rem;
        margin: 0.2rem 0 0.2rem 0rem;
        .time{
          text-align: center;
          color: rgb(243, 95, 95);
          background-color: rgb(242, 225, 225);
          font-size: 0.4rem;
          .block{
            font-size: 0.35rem;
             display: inline-block;
             padding-left: 0.1rem;
          }
          .c1{
            color: rgb(247, 17, 17);
            font-size: 0.35rem;
          }
          .xs{
            color: rgb(14, 14, 14);
            font-size: 0.38rem;
            span{
            color: rgb(247, 17, 17);
              font-size: 0.4rem;
            }
          }
        }

        .con{
        background-color: rgb(238, 236, 236);

        }
        .tao{
          width: 100%;
        }
        .price {
          height: 0.5rem;
          line-height: 0.5rem;
          font-size: 0.4rem;
          color: #a22d2b;
        }
        .name {
          font-size: 0.373333rem;
            padding-top: 0.2rem;

          color: #333;


        }
        .progress{
            // overflow: hidden;
            padding-top: 0.2rem;
           margin-left: 3rem;
            width: 65%;
        }
        .num{
            // float: right;
            // height: 2rem;
            text-align: right;
            padding-right: 0.2rem;
            // line-height: -2rem;
        }
        .name2 {
          font-size: 0.373333rem;
          color: #333;
         padding: 0.1rem;
         padding-top: 0.2rem;
        }
         .name3 {
          font-size: 0.373333rem;
          color: rgb(241, 49, 49);
         padding: 0.1rem;
        //  padding-top: 0.2rem;
        }
      }
    }
  }
</style>